import { AddonItem } from '@customTypes/booking-details';
import useShowMore from '@hooks/useShowMore';
import React from 'react';
import ShowMore from './ShowMore/ShowMore';
import MultiLineCheckbox from './Checkbox/MultiLineCheckbox';

type Props = {
  addons: AddonItem[];
  updateAddonItem: (item: AddonItem, value: boolean) => void;
  showAddons: boolean;
  onAddonUnitsSelect: (value: string, item: AddonItem) => void;
};

export default function Addons({ addons, onAddonUnitsSelect, showAddons, updateAddonItem }: Props) {
  const { showAll, onShowMoreClick, showMoreButtonText } = useShowMore();

  return showAddons ? (
    <div className="py-6 border-b border-rp-gray-divider">
      <div className="flex items-center justify-between">
        <p className="text-17 leading-20.71px font-rp-pn-semi-bold text-rp-primary-black">
          Add-Ons
        </p>

        {addons.length > 4 && (
          <button
            type="button"
            onClick={onShowMoreClick}
            className="text-base leading-6 font-rp-pn-semi-bold text-rp-primary-light-5"
          >
            {showMoreButtonText}
          </button>
        )}
      </div>

      <ShowMore initialCount={4} showAll={showAll} classes="mt-6 flex flex-col space-y-6">
        {addons.map((item: AddonItem) => (
          <div key={item.id} className="flex justify-between items-center">
            <div className="font-rp-pn-semi-bold w-3/4">
              <MultiLineCheckbox
                checked={item.isChecked || false}
                id={item.id.toString()}
                onChange={(value: boolean) => updateAddonItem(item, value)}
                label={item.name}
                currency={item.price.toString()}
              />
            </div>

            {item.type !== 'single' && (
              <select
                onChange={
                  (e: React.ChangeEvent<HTMLSelectElement>) =>
                    onAddonUnitsSelect(e.target.value, item)
                  // eslint-disable-next-line react/jsx-curly-newline
                }
                value={item.units}
                className="w-20 h-10 border pl-6 rounded-xl text-base d:text-17 d:w-20 border-rp-gray-divider bg-white shadow-select"
              >
                <option key={0} value={0} disabled>
                  0
                </option>

                {Array.from(Array(item.max).keys()).map((num) => (
                  <option key={num + 1} value={num + 1}>
                    {num + 1}
                  </option>
                ))}
              </select>
            )}
          </div>
        ))}
      </ShowMore>
    </div>
  ) : null;
}
